module.exports = __webpack_public_path__ + "21d3af5a93b7daccdbc51918700fa627.png";